import { FC, lazy, Suspense } from 'react';

import { useAuth } from '@shared/state/hooks/useAuth';
import { Navigate, Route, Routes } from 'react-router-dom';

//* 관리자만 쓰는 개발 도구라 로그인 전 번들에 싣지 않는다
const GifticonGatewayTestPage = lazy(
  () => import('@service/admin/gifticonTest/GifticonGatewayTestPage'),
);
const AddconGoodsCatalogPage = lazy(
  () => import('@service/admin/gifticonTest/AddconGoodsCatalogPage'),
);
const AddconDashboardPage = lazy(
  () => import('@service/admin/giftApiDashboard/AddconDashboardPage'),
);

/**
 * /gift-api — 애드콘 API 발행 현황(대시보드, 진입점) · /gift-api/test 발송 테스트 · /gift-api/goods 계약 상품. 백엔드 /admin/gifticon-test/* 가 Admin·GiftAgent 전용이라
 * 화면도 그 권한으로 로그인한 뒤에만 연다 (AdminAuthRouter와 같은 복귀 규칙).
 */
export const GiftApiRouter: FC = function GiftApiRouter() {
  const { isAdmin, isGiftAgent } = useAuth();
  //* 백엔드 @Roles(Admin, GiftAgent)와 동일 범위
  if (!isAdmin() && !isGiftAgent()) {
    sessionStorage.setItem('redirectUrlAfterAdminLogin', window.location.pathname);
    return <Navigate to="/admin/login" />;
  }
  return (
    <Suspense
      fallback={
        <div role="status" className="p-6 text-sm text-gray-500">
          애드콘 화면을 불러오는 중입니다…
        </div>
      }
    >
      <Routes>
        <Route index element={<AddconDashboardPage />} />
        <Route path="test" element={<GifticonGatewayTestPage />} />
        <Route path="goods" element={<AddconGoodsCatalogPage />} />
        {/* 예전 링크 호환 */}
        <Route path="dashboard" element={<Navigate to="/gift-api" replace />} />
        <Route path="*" element={<Navigate to="/gift-api" replace />} />
      </Routes>
    </Suspense>
  );
};
